module.exports = __webpack_public_path__ + "img/y_img.38b70c6.png";